var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.714844,
    width: 54.2857,
    height: 54.2857,
    rx: 27.1429,
    fill: "url(#paint0_linear_287_6254)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.28032,
    y: 0.565476,
    width: 53.1548,
    height: 53.1548,
    rx: 26.5774,
    stroke: "url(#paint1_linear_287_6254)",
    strokeOpacity: 0.2,
    strokeWidth: 1.13095
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3588 14.9287H18.3588C16.866 14.9287 15.6445 16.1501 15.6445 17.643V36.643C15.6445 38.1372 16.866 39.3573 18.3588 39.3573H27.8588V29.8573H25.1445V26.4984H27.8588V23.7162C27.8588 20.7794 29.5037 18.7165 32.9698 18.7165L35.4167 18.7192V22.2546H33.7922C32.4432 22.2546 31.9302 23.267 31.9302 24.2061V26.4997H35.4154L34.6445 29.8573H31.9302V39.3573H37.3588C38.8517 39.3573 40.0731 38.1372 40.0731 36.643V17.643C40.0731 16.1501 38.8517 14.9287 37.3588 14.9287Z",
    fill: "url(#paint2_linear_287_6254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_6254",
    x1: 0.714844,
    y1: 0,
    x2: 62.8744,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_6254",
    x1: 0.714844,
    y1: 0,
    x2: 62.8744,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_6254",
    x1: 15.6445,
    y1: 14.9287,
    x2: 43.6163,
    y2: 20.0664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5603b775090f3c04dcfe13cde6887cca.svg";
export { ForwardRef as ReactComponent };